module.exports = __webpack_public_path__ + "img/rapi_icon_client.510987be.png";